/**
 * The schedule as a sentence ("Every Monday at 09:00"), shared by the
 * wizard's review step and the subscriptions table — one phrasing, not
 * two. Takes `t` as an argument so it stays importable from non-React
 * code and testable under the node vitest environment.
 */

import type { TParams } from "@/i18n";
import {
  WEEKDAY_ORDER,
  scheduleFromCron,
  type ScheduleState,
} from "@/pages/delivery/delivery-form";

type TFunc = (key: string, params?: TParams) => string;

export function summarizeSchedule(s: ScheduleState, t: TFunc): string {
  switch (s.kind) {
    case "daily":
      return t("delivery.schedule.summary.daily", { time: s.time });
    case "weekly": {
      const days = s.weekdays
        .slice()
        .sort((a, b) => WEEKDAY_ORDER.indexOf(a) - WEEKDAY_ORDER.indexOf(b))
        .map((d) => t(`delivery.weekday.${d}`))
        .join(", ");
      return t("delivery.schedule.summary.weekly", { days, time: s.time });
    }
    case "monthly":
      return t("delivery.schedule.summary.monthly", {
        day: s.monthDay,
        time: s.time,
      });
    case "custom":
      return t("delivery.schedule.summary.custom", { cron: s.rawCron });
  }
}

export function summarizeCron(cron: string, t: TFunc): string {
  return summarizeSchedule(scheduleFromCron(cron), t);
}
